<div class="counter-layout-component-container scrollable-component-container">
  <div class="attribute-editor-component">
    <div
      class="scrollable-component-settings te-scrollable-container counter-layout-component-settings"
    >
      <!-- Choose a counter type — always exactly two options: the persisted
           direction (Down or Up, never both) plus Daily. Switching *between*
           Down and Up isn't offered, since whether an existing template's own
           rendering script reacts correctly to that isn't knowable from this
           panel (some hardcode their own down-only date math). Daily is safe
           regardless of direction because it never changes the persisted
           type. -->
      <div class="attribute-editor-row">
        <label id="base-counter-type-label">Choose a counter type</label>
        <div class="form-group layout-selector">
          <div
            class="layout-container"
            role="radiogroup"
            aria-labelledby="base-counter-type-label"
          >
            @if (persistedType === CounterType.DOWN) {
              <button
                #counterTypeBtn
                type="button"
                class="layout-option counter-type-option"
                [ngClass]="{
                  'layout-option--selected': counterType === CounterType.DOWN,
                }"
                (click)="setCounterType(CounterType.DOWN)"
                (keydown)="onCounterTypeKeydown($event, CounterType.DOWN)"
                [attr.aria-checked]="counterType === CounterType.DOWN"
                [attr.tabindex]="
                  counterType === CounterType.DOWN || !counterType ? 0 : -1
                "
                role="radio"
              >
                <div class="layout-icon-container counter-type-icon-container">
                  <!--
                    Count down: outlined circle (green) with downward arrow.
                    Arrow derived from icon/arrow-left rotated -90°.
                    Down arrow: shaft M16.5 10.5V22.5, head M11 17L16.5 22.5L22 17
                  -->
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 33 33"
                    fill="none"
                  >
                    <circle
                      cx="16.5"
                      cy="16.5"
                      r="15"
                      stroke="#1ea861"
                      stroke-width="1.5"
                    />
                    <path
                      d="M16.5 10.5V22.5M11 17l5.5 5.5 5.5-5.5"
                      stroke="#1ea861"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="counter-type-text">
                  <div class="layout-label">Count down</div>
                  <div class="counter-type-description">
                    Count down to a future date
                  </div>
                </div>
              </button>
            } @else if (persistedType === CounterType.UP) {
              <button
                #counterTypeBtn
                type="button"
                class="layout-option counter-type-option"
                [ngClass]="{
                  'layout-option--selected': counterType === CounterType.UP,
                }"
                (click)="setCounterType(CounterType.UP)"
                (keydown)="onCounterTypeKeydown($event, CounterType.UP)"
                [attr.aria-checked]="counterType === CounterType.UP"
                [attr.tabindex]="counterType === CounterType.UP ? 0 : -1"
                role="radio"
              >
                <div class="layout-icon-container counter-type-icon-container">
                  <!--
                    Count up: outlined circle (blue) with upward arrow.
                    Arrow derived from icon/arrow-left rotated +90°.
                    Up arrow: shaft M16.5 22.5V10.5, head M11 16l5.5-5.5 5.5 5.5
                  -->
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    viewBox="0 0 33 33"
                    fill="none"
                  >
                    <circle
                      cx="16.5"
                      cy="16.5"
                      r="15"
                      stroke="#3B82F6"
                      stroke-width="1.5"
                    />
                    <path
                      d="M16.5 22.5V10.5M11 16l5.5-5.5 5.5 5.5"
                      stroke="#3B82F6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="counter-type-text">
                  <div class="layout-label">Count up</div>
                  <div class="counter-type-description">
                    Count up from a past date
                  </div>
                </div>
              </button>
            }

            <button
              #counterTypeBtn
              type="button"
              class="layout-option counter-type-option"
              [ngClass]="{
                'layout-option--selected': counterType === CounterType.DAILY,
              }"
              (click)="setCounterType(CounterType.DAILY)"
              (keydown)="onCounterTypeKeydown($event, CounterType.DAILY)"
              [attr.aria-checked]="counterType === CounterType.DAILY"
              [attr.tabindex]="counterType === CounterType.DAILY ? 0 : -1"
              role="radio"
            >
              <div class="layout-icon-container counter-type-icon-container">
                <!--
                  Repeat daily: exact paths from Figma export (Frame 1321315660).
                  Translated so the circle is centered in a 33×33 viewBox.
                -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  viewBox="0 0 33 33"
                  fill="none"
                >
                  <g transform="translate(-9.483 0.09)">
                    <path
                      d="M30.4958 14.3591L33.3676 11.4873L30.4958 8.61548M33.3676 11.4873L21.8804 11.4874C21.01 11.4874 20.1752 11.8331 19.5597 12.4486C18.9442 13.0641 18.5984 13.899 18.5984 14.7694V16.4104M21.4702 18.4616L18.5984 21.3334L21.4702 24.2052M18.5984 21.3334L30.0856 21.3333C30.956 21.3333 31.7908 20.9876 32.4063 20.3721C33.0218 19.7566 33.3676 18.9218 33.3676 18.0513V16.4103"
                      stroke="#A855F7"
                      stroke-width="1.67"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="25.983"
                      cy="16.4103"
                      r="15.5753"
                      stroke="#A855F7"
                      stroke-width="1.67"
                    />
                  </g>
                </svg>
              </div>
              <div class="counter-type-text">
                <div class="layout-label">Repeat daily</div>
                <div class="counter-type-description">
                  {{
                    persistedType === CounterType.UP
                      ? 'Count up from a time every day'
                      : 'Count down to a time every day'
                  }}
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      <!-- Target date (hidden for Repeat daily) -->
      @if (counterType !== CounterType.DAILY) {
        <div class="attribute-editor-row">
          <label for="base-counter-target-date">{{
            persistedType === CounterType.UP ? 'Start date' : 'Target date'
          }}</label>
          <mat-form-field
            appearance="outline"
            class="date-picker counter-date-time-field"
          >
            <button
              mat-icon-button
              matPrefix
              type="button"
              (click)="targetDatePicker.open()"
              aria-label="Open date picker"
            >
              <mat-icon svgIcon="calendar"></mat-icon>
            </button>
            <input
              matInput
              [matDatepicker]="targetDatePicker"
              id="base-counter-target-date"
              name="baseCounterTargetDate"
              [(ngModel)]="targetDate"
              ngDefaultControl
              placeholder="MM/DD/YYYY"
              (dateChange)="save()"
            />
            <mat-datepicker
              #targetDatePicker
              [calendarHeaderComponent]="calendarMonthYearHeader"
              [startAt]="matDatepickerConfig.startAt"
              [startView]="matDatepickerConfig.startView"
            />
          </mat-form-field>
        </div>
      }

      <!-- Target time -->
      <div class="attribute-editor-row">
        <label for="base-counter-target-time">{{
          persistedType === CounterType.UP ? 'Start time' : 'Target time'
        }}</label>
        <mat-form-field
          appearance="outline"
          class="date-picker counter-date-time-field"
        >
          <button
            mat-icon-button
            matPrefix
            type="button"
            aria-label="Select time"
            (click)="targetTimePicker.open()"
          >
            <mat-icon svgIcon="alarm-clock"></mat-icon>
          </button>
          <!-- (change), not (ngModelChange): MatTimepickerInput updates the model
               on every keystroke, so ngModelChange would save() mid-typing on an
               incomplete/invalid value. The native change event only fires on blur.
               (selected) on mat-timepicker below covers overlay-driven picks, which
               never dispatch a native change event on the input. -->
          <input
            matInput
            [matTimepicker]="targetTimePicker"
            id="base-counter-target-time"
            name="baseCounterTargetTime"
            [(ngModel)]="targetTime"
            ngDefaultControl
            (change)="save()"
          />
          <mat-timepicker
            #targetTimePicker
            interval="15m"
            (selected)="save()"
          />
        </mat-form-field>
      </div>

      <!-- Completion message (hidden for Up-configured components — including
           Repeat Daily under Up, since counterType is 'daily' there rather
           than 'up' — or when the template disables it) -->
      @if (persistedType !== CounterType.UP && !nonCompletion) {
        <div class="attribute-editor-row">
          <div class="form-group">
            <label for="base-counter-completion-message"
              >Completion message (optional)</label
            >
            <input
              type="text"
              id="base-counter-completion-message"
              name="baseCounterCompletionMessage"
              class="form-control"
              [(ngModel)]="completionMessage"
              placeholder="It's the big day!"
              (change)="save()"
            />
          </div>
        </div>
      }
    </div>
  </div>
</div>
